import APIService from '@/services/api';
import {IGeoIP} from '@/shared/services/models/GeoIP';

import Vue from 'vue';

import { Module } from 'vuex';

export interface GeoStoreState {
    locations: { [key: string]: IGeoIP };
}
const geoIPModule: Module<any, any> = {
    namespaced: true,
    state: {
        locations: {},
    } as GeoStoreState,

    getters: {
        getGeoIP(state: any, getters): IGeoIP | undefined {
            return state[getters.ip];
        },
    },

    mutations: {
        updateGeoIP(state, {ip, geoip}) {
            Vue.set(state.locations, ip, geoip);
        },
    },

    actions: {
        async loadGeoIP({ commit }, ip) {
            const geoip: IGeoIP = await APIService.GetGeoIP(ip);
            commit('updateGeoIP', { ip, geoip });
        },
    },
};

export default geoIPModule;
